import dayjs from 'dayjs'
import { ViewModel } from './_vm'
import ConfigForm from './service/_config'
import { dateFormat, objectToGet } from '../functions/index'
import closingDay from '../const/_closing-day'
import UiStore from '../store/_ui-store'

/**
 * TopRoomChange // datePicker描写のjs
 *
 * @returns {undefined}
 */
export class TopRoomChange extends ViewModel {
  constructor($element, controller) {
    super(TopRoomChange.name(), $element, controller)

    const direct_config = ConfigForm.init()
    if (direct_config.departureDate === undefined) {
      const cDay = objectToGet(closingDay, '2.day', 14)
      direct_config.departureDate = dayjs().add(cDay, 'day')
    } else {
      direct_config.departureDate = dayjs(dateFormat(direct_config.departureDate, 'YYYY-MM-DD'))
    }

    // 年と月の初期化
    this.$text = this.$element.find('.roomChange__selectedText')
    this.$body = this.$element.find('.roomChange__modalWrap')
    this.$display = this.$element.find('.selectday')
    this.class = 'roomChange--show'

    // イベントの登録
    this.on(`dateUndecided`, () => this.changeDisplay())
    this.on(`TopRoomChange:render`, () => this.render())

    this.$element.find('.js-kaigai-room-change-modal').on('click', () => this.show())
    this.$element.find('.js-room-change-btn').on('click', () => this.close())

    this.render()
  }

  static name() {
    return 'TopRoomChange'
  }

  static className() {
    return '.js-kaigai-room-change-target'
  }

  changeDisplay() {
    if ($('#NTA_date_undecided-check').prop('checked')) this.$display.css('background-color', '#A0A0A0')
    else this.$display.css('background-color', '')
  }

  showCalendar() {
    if (!$('#NTA_date_undecided-check').prop('checked')) this.$element.addClass(this.datePickerClass)
  }

  show() {
    this.$element.addClass(this.class)
  }

  close() {
    const roomList = UiStore.getData('lockRooms.roomList', [[20, 20]])
    const peopleNum = roomList.join().split(',').length
    if (peopleNum > 9) return
    this.$element.removeClass(this.class)
  }

  init() {
    // イベントの初期化
  }

  render() {
    let peopleNumRoomNum = ''
    const roomList = UiStore.getData('lockRooms.roomList', [[20, 20]])
    const roomNum = roomList.length
    const totalAdult = UiStore.getData(`totalAdult`, 2)
    const totalChild = UiStore.getData(`totalChild`, 0)
    const totalInf = UiStore.getData(`totalInf`, 0)
    peopleNumRoomNum = roomNum + '部屋／大人' + totalAdult + '名　子供' + totalChild + '名　幼児' + totalInf + '名'
    this.$text.empty()
    this.$text.append(peopleNumRoomNum)

    this.init()
  }
}
